import AccountForm from "./auth-fe23.esm.js";
import React from "react";
//#region src/AccountForm/AccountFormV2/AccountFormV2.tsx
var AccountFormV2 = (props) => /* @__PURE__ */ React.createElement(AccountForm, props);
//#endregion
export { AccountFormV2 };

